import { render, staticRenderFns } from "./schoolInfo.vue?vue&type=template&id=5bdda319&scoped=true&"
import script from "./schoolInfo.vue?vue&type=script&lang=js&"
export * from "./schoolInfo.vue?vue&type=script&lang=js&"
import style0 from "./schoolInfo.vue?vue&type=style&index=0&id=5bdda319&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdda319",
  null
  
)

export default component.exports